module.exports = __webpack_public_path__ + "img/images-user.499b4e51.svg";